// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const DownArrow: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="11" viewBox="0 0 9 11">
            <path
                fill="currentColor"
                d="M8.77957034,6.50859404 L5.02957034,10.258594 C4.88425756,10.40625 4.69207013,10.4789064 4.4998827,10.4789064 C4.30769527,10.4789064 4.11597633,10.4056642 3.96972656,10.2591798 L0.219726562,6.50917983 C-0.0732421875,6.21621108 -0.0732421875,5.74160171 0.219726562,5.44863296 C0.512695312,5.15566421 0.987304688,5.15566421 1.28027344,5.44863296 L3.7498827,7.91953111 L3.7498827,0.728906393 C3.7498827,0.314296961 4.08574212,0 4.47878909,0 C4.87183607,0 5.2498827,0.314296961 5.2498827,0.728906393 L5.2498827,7.91953111 L7.72019506,5.44921875 C8.01316381,5.15625 8.48777318,5.15625 8.78074193,5.44921875 C9.07371068,5.7421875 9.07253909,6.21562529 8.77957034,6.50859404 Z"
                transform="translate(0 .271)"
            />
        </svg>
    );
};

export default React.memo(DownArrow);
